import { toast } from 'react-toastify';
import closeIcon from '../assets/svgs/close-toast-icon.svg';
import 'twin.macro';

export const showSuccess = (message, title, _ToastOptions) =>
  toast(
    <div>
      <div className="toast-title" tw="text-[14px] font-bold">
        {title}
      </div>
      <div
        className="toast-subtitle"
        tw="text-[14px]"
        dangerouslySetInnerHTML={{ __html: message }}
      />
    </div>,
    {
      className: 'Toastify__toast--custom',
      closeButton: (
        <button tw="absolute top-4 right-4 text-gray-text">
          <img loading="lazy" decoding="async" src={closeIcon} alt="close" tw="w-[9] h-[9]" />
        </button>
      ),
      closeOnClick: true,
      hideProgressBar: true,
      autoClose: true,
    }
  );

export const showError = (message, title, _ToastOptions) =>
  toast(
    <div>
      <div className="toast-title" tw="text-[14px] font-bold">
        {title}
      </div>
      <div className="toast-subtitle" tw="text-[14px]">
        {message}
      </div>
    </div>,
    {
      className: 'Toastify_error__toast--custom',
      closeButton: (
        <button tw="absolute top-4 right-4 text-gray-text">
          <img loading="lazy" decoding="async" src={closeIcon} alt="close" tw="w-[9] h-[9]" />
        </button>
      ),
      closeOnClick: true,
      hideProgressBar: true,
      autoClose: true,
    }
  );

export const showInfo = (message, _ToastOptions) =>
  toast.info(
    <div>
      <span>{message}</span>
    </div>,

    _ToastOptions
  );
